"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MaterialDefinition() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="materialdefinition" className="bg-background">
      <div className="bg-accent text-accent-foreground py-16 md:py-24 lg:py-32">
        <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-8 tracking-tight">
            What Is Engraving-Grade Phenolic?
          </h2>

          <div className="space-y-6 font-sans">
            <p className="text-xl md:text-2xl font-medium leading-relaxed">
              Engraving-grade phenolic is a thermoset plastic laminate built in layers — a thin colored cap bonded over a contrasting core. Engraving removes the cap to reveal the core, producing permanent two-color text that is part of the material, not printed on it.
            </p>

            <p className="text-base md:text-lg leading-relaxed opacity-90">
              Evermark Industrial Solutions uses phenolic because the cured thermoset resists solvents, abrasion, heat, and electrical environments. Its dielectric strength and dimensional stability make it the long-standing choice for control-panel identification and defense nameplates, where a printed or thermoplastic label would not hold up.
            </p>

            
          </div>
        </div>
      </div>
    </section>;
}